import { render, staticRenderFns } from "./dispose.vue?vue&type=template&id=79fa4d46&scoped=true&"
import script from "./dispose.vue?vue&type=script&lang=js&"
export * from "./dispose.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79fa4d46",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\www\\ssz_gold_backend\\multi_merchant_web\\gold_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79fa4d46')) {
      api.createRecord('79fa4d46', component.options)
    } else {
      api.reload('79fa4d46', component.options)
    }
    module.hot.accept("./dispose.vue?vue&type=template&id=79fa4d46&scoped=true&", function () {
      api.rerender('79fa4d46', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/complaint/dailog/dispose.vue"
export default component.exports